import { render, staticRenderFns } from "./CompanyWorkplaces.vue?vue&type=template&id=0b2f4c0a&scoped=true&"
import script from "./CompanyWorkplaces.vue?vue&type=script&lang=js&"
export * from "./CompanyWorkplaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2f4c0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemIcon } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VDataTable,VDialog,VIcon,VListItemIcon})
